import { render, staticRenderFns } from "./BelegungsplanPopover.vue?vue&type=template&id=25facb58&"
import script from "./BelegungsplanPopover.vue?vue&type=script&lang=ts&"
export * from "./BelegungsplanPopover.vue?vue&type=script&lang=ts&"
import style0 from "./BelegungsplanPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports